export class JfkConfig {
  jfkUrl: string;
  jfkEnvHeader: string;
  channelCode: string;
  serviceRegistryKey: string;
  portName: string;
  serviceRegistryInterface: string;

  constructor(
    url: string,
    env: string,
    channelCode: string,
    serviceRegistryKey: string,
    portName: string,
    serviceRegistryInterface: string
  ) {
    this.jfkUrl = url;
    this.jfkEnvHeader = env;
    this.channelCode = channelCode;
    this.serviceRegistryKey = serviceRegistryKey;
    this.portName = portName;
    this.serviceRegistryInterface = serviceRegistryInterface;
  }
}
